// Main-thread proxy for the simulation engine running in a Web Worker.
//
// Owns the Worker, exposes a small command API, and surfaces the latest
// snapshot via the onSnapshot callback. All communication is asynchronous;
// the view never blocks on the worker.

export class EngineClient {
    constructor() {
        this.worker = new Worker(new URL('../engine/engine-worker.js', import.meta.url), { type: 'module' });
        this.onSnapshot = null;
        this.worker.onmessage = (e) => {
            const msg = e.data || {};
            if (msg.type === 'snapshot' && this.onSnapshot) {
                this.onSnapshot(msg);
            }
        };
    }

    _post(msg) {
        this.worker.postMessage(msg);
    }

    init(ownShip, tracks, clock = 0) {
        this._post({ type: 'init', ownShip, tracks, clock });
    }

    setRunning(running) { this._post({ type: 'setRunning', running }); }
    setSpeed(simSpeed) { this._post({ type: 'setSpeed', simSpeed }); }
    editOwnShip(field, value) { this._post({ type: 'editOwnShip', field, value }); }
    editTrack(id, field, value) { this._post({ type: 'editTrack', id, field, value }); }
    addTrack(track) { this._post({ type: 'addTrack', track }); }
    dropTrack(id) { this._post({ type: 'dropTrack', id }); }
    dragStart(id) { this._post({ type: 'dragStart', id }); }
    dragEnd(id) { this._post({ type: 'dragEnd', id }); }

    destroy() {
        this.worker.terminate();
        this.worker = null;
    }
}
